import { classNames } from '../../lib/utils';
import React, { ReactNode } from 'react';
import useMediaQuery from '../Hooks/useMediaQuery';
import './statcards.css';

type Props = {
  summary: StatsSummary[];
  showLoader?: boolean;
  activeTabIndex?: number;
  onTabChange?: (prm: number) => void;
  isTab?: boolean;
  cardWidth?: `${string}px`;
};

export interface StatsSummary {
  name: string | ReactNode;
  value: number | string;
}

const StatCards: React.FC<Props> = (props)  => {
  const isDesktopView = useMediaQuery('(min-width: 767px)');

  function onTabClick(idx: number) {
    if (
      !props.showLoader &&
      props.onTabChange &&
      props.activeTabIndex !== idx
    ) {
      props.onTabChange(idx);
    }
  }
  return (
    <div className='app-stats-card flex my-[25px] overflow-x-scroll gap-2 scroll-smooth'>
      {props.summary.map((item, idx) => (
        <div
          style={{
            width:
              props.summary.length < 2 && isDesktopView && props.cardWidth
                ? props.cardWidth
                : '',
          }}
          className={classNames(
            'stats-container',
            props.isTab && props.activeTabIndex === idx ? 'active-tab' : '',
            props.isTab ? 'cursor-pointer' : ''
          )}
          key={idx}
          onClick={() => onTabClick(idx)}
        >
          <p className='heading'>{item.name}</p>
          <div className='stats'>
            {props.showLoader ? (
              <span className='loading-circle loading-circle-small mt-1-5 '></span>
            ) : (
              <p className='value'>{item.value}</p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatCards;
